import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import api from '../services/api';

/**
 * Members-only videos (Jenn, 2026-11-03). Every video link we hand out —
 * "Copy link" in the Video Library, emails, texts — opens here.
 * Active members (signed in, or with their own emailed/texted link) and
 * Team365 watch straight away; public videos play for anyone; everyone else
 * sees "This is for 365reset members, here's how to join."
 */
export default function Watch() {
  const { videoId } = useParams();
  const [search] = useSearchParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    const k = search.get('k');
    api.get(`/watch/${videoId}`, { params: k ? { k } : {} })
      .then(r => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, ok: false, error: true }));
  }, [videoId, search]);

  if (state.loading) {
    return <div className="min-h-screen bg-reset-cream" aria-busy="true" />;
  }

  if (state.ok) {
    return (
      <div className="min-h-screen bg-reset-cream px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-3xl font-bold text-reset-brown mb-4">{state.title || '365reset video'}</h1>
          <div className="relative w-full rounded-2xl overflow-hidden shadow-sm bg-black" style={{ paddingTop: '56.25%' }}>
            <iframe
              src={state.embedUrl}
              title={state.title || '365reset video'}
              className="absolute inset-0 w-full h-full border-0"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
              allowFullScreen
            />
          </div>
          <p className="mt-6 text-sm">
            <Link to="/dashboard" className="font-medium text-reset-terracotta hover:underline">Go to my Hub →</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-reset-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm p-8 text-center">
        <h1 className="font-serif text-3xl font-bold text-reset-brown mb-3">This is for 365reset members</h1>
        {state.title && <p className="text-sm font-medium text-reset-brown mb-3">{state.title}</p>}
        <p className="text-sm text-gray-600 mb-6">
          {state.error
            ? 'We couldn\'t load this video just now. Please try again in a moment.'
            : 'This video is part of the 365reset membership. Here\'s how to join, and get every replay, course and live session in the Hub.'}
        </p>
        <Link to="/join" className="inline-block px-5 py-3 bg-reset-terracotta text-white text-sm font-semibold rounded-xl hover:bg-reset-brown transition-colors">
          How to join 365reset
        </Link>
        <p className="mt-6 text-sm text-gray-500">
          Already a member?{' '}
          <Link to="/auth/login" state={{ from: { pathname: `/watch/${videoId}` } }} className="font-medium text-reset-terracotta hover:underline">
            Sign in to watch →
          </Link>
        </p>
      </div>
    </div>
  );
}
